
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Hooks/useAutosizeTextArea.html",
      function () {
        return require("private-next-pages/Hooks/useAutosizeTextArea.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Hooks/useAutosizeTextArea.html"])
      });
    }
  